// DROPAVANZADO · Premium interactions (Apple-style)
(function(){
  'use strict';
  
  // Reveal on scroll (IntersectionObserver)
  function initReveal(){
    var els = document.querySelectorAll('.da-reveal:not(.is-visible)');
    if(!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function(e){ e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(e){ io.observe(e); });
  }
  
  // Auto-aplicar reveal a secciones principales
  function autoReveal(){
    var selectors = [
      '.dropavanzado-reviews__card',
      '.da-card',
      '.dropavanzado-benefit',
      '.dropavanzado-step'
    ];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el, idx){
        if(!el.classList.contains('da-reveal')){
          el.classList.add('da-reveal');
          el.setAttribute('data-delay', (idx % 3) + 1);
        }
      });
    });
    initReveal();
  }
  
  // Smooth scroll para anclas
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if(!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if(target){
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  
  // Parallax sutil en heroes
  function initParallax(){
    var els = document.querySelectorAll('.da-parallax');
    if(!els.length) return;
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var sy = window.scrollY;
        els.forEach(function(el){
          var rect = el.getBoundingClientRect();
          if(rect.bottom > 0 && rect.top < window.innerHeight){
            var offset = (sy - el.offsetTop) * 0.08;
            el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
          }
        });
        ticking = false;
      });
    }, {passive:true});
  }
  
  // Contadores animados
  function initCounters(){
    var els = document.querySelectorAll('[data-count]');
    if(!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        io.unobserve(en.target);
        var target = parseFloat(en.target.dataset.count);
        var dur = 1200, start = null;
        function step(ts){
          if(!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          en.target.textContent = Math.round(target * eased).toLocaleString();
          if(p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, {threshold: .5});
    els.forEach(function(e){ io.observe(e); });
  }
  
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ autoReveal(); initParallax(); initCounters(); });
  } else {
    autoReveal(); initParallax(); initCounters();
  }
})();

// --- Reveal on scroll ---
(function(){
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('da-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    
    document.querySelectorAll('.dropavanzado-buybox, .dropavanzado-sellos, .da-video-reviews, .dropavanzado-reviews, .dropavanzado-faq').forEach(function(el){
      el.classList.add('da-reveal');
      io.observe(el);
    });
  }
  
  // --- Sticky ATC show/hide ---
  var sticky = document.querySelector('.da-sticky-atc');
  var buybox = document.querySelector('.dropavanzado-buybox');
  if(sticky && buybox && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        sticky.classList.toggle('da-show', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(buybox);
  }
})();
